import {Directive, Input, OnDestroy, OnInit, Renderer2} from "@angular/core";

@Directive({
  selector: '[bodyClass]',
  standalone: true
})
export class BodyClassDirective implements OnInit, OnDestroy {
  @Input('bodyClass') classNames!: string | string[];

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    const classes = Array.isArray(this.classNames) ? this.classNames : [this.classNames];
    classes.forEach(cls => this.renderer.addClass(document.body, cls));
  }

  ngOnDestroy() {
    const classes = Array.isArray(this.classNames) ? this.classNames : [this.classNames];
    classes.forEach(cls => this.renderer.removeClass(document.body, cls));
  }
}
